'use es6';

import ErrorHandler from 'simple-menus-lib/components/ErrorHandler';
import MenuErrorState from 'simple-menus-lib/components/menu/MenuErrorState';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withErrorHandler() {
  return Component => {
    return props => {
      return /*#__PURE__*/_jsx(ErrorHandler, {
        errorComponent: /*#__PURE__*/_jsx(MenuErrorState, {}),
        children: /*#__PURE__*/_jsx(Component, Object.assign({}, props))
      });
    };
  };
}